// extracted by mini-css-extract-plugin
export default {"Paragraph":"RenderSlateElement_Paragraph__iJJZ6","ParagraphDragging":"RenderSlateElement_ParagraphDragging__mdoQh"};